import { createSlice } from "@reduxjs/toolkit";

export const counterSlice = createSlice({
  name: "slice",
  initialState: {
    value: 0,
  },
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
  },
});

export default counterSlice.reducer;
export const { increment, decrement } = counterSlice.actions;
